module.exports.default = [
    {
        "name": "Basque",
        "code": "eu",
        "translations": 54,
        "percentage": 35.29,
        "updated": "2021-11-09T07:22:35+0000"
    },
    {
        "name": "Bulgarian",
        "code": "bg",
        "translations": 26,
        "percentage": 16.99,
        "updated": "2020-06-04T07:40:46+0000"
    },
    {
        "name": "Catalan",
        "code": "ca",
        "translations": 54,
        "percentage": 35.29,
        "updated": "2021-11-09T07:22:46+0000"
    },
    {
        "name": "Danish",
        "code": "da",
        "translations": 26,
        "percentage": 16.99,
        "updated": "2020-06-04T07:41:35+0000"
    },
    {
        "name": "Dutch",
        "code": "nl",
        "translations": 105,
        "percentage": 68.63,
        "updated": "2021-05-23T09:52:47+0000"
    },
    {
        "name": "English",
        "code": "en",
        "translations": 153,
        "percentage": 100,
        "updated": "2023-03-26T12:54:04+0000"
    },
    {
        "name": "Finnish",
        "code": "fi",
        "translations": 33,
        "percentage": 21.57,
        "updated": "2023-03-13T11:34:37+0000"
    },
    {
        "name": "French",
        "code": "fr",
        "translations": 130,
        "percentage": 84.97,
        "updated": "2023-03-26T12:54:27+0000"
    },
    {
        "name": "Galician",
        "code": "gl",
        "translations": 54,
        "percentage": 35.29,
        "updated": "2021-11-09T07:23:00+0000"
    },
    {
        "name": "German",
        "code": "de",
        "translations": 78,
        "percentage": 50.98,
        "updated": "2023-03-26T12:54:22+0000"
    },
    {
        "name": "Greek",
        "code": "el",
        "translations": 30,
        "percentage": 19.61,
        "updated": "2022-11-08T10:13:19+0000"
    },
    {
        "name": "Hebrew",
        "code": "he",
        "translations": 85,
        "percentage": 55.56,
        "updated": "2022-11-20T08:39:43+0000"
    },
    {
        "name": "Italian",
        "code": "it",
        "translations": 81,
        "percentage": 52.94,
        "updated": "2023-03-26T12:54:18+0000"
    },
    {
        "name": "Polish",
        "code": "pl",
        "translations": 26,
        "percentage": 16.99,
        "updated": "2020-06-04T07:55:45+0000"
    },
    {
        "name": "Portuguese",
        "code": "pt",
        "translations": 104,
        "percentage": 67.97,
        "updated": "2022-11-03T10:28:44+0000"
    },
    {
        "name": "Portuguese (BR)",
        "code": "pt-br",
        "translations": 128,
        "percentage": 83.66,
        "updated": "2023-03-26T12:54:13+0000"
    },
    {
        "name": "Romanian",
        "code": "ro",
        "translations": 26,
        "percentage": 16.99,
        "updated": "2020-06-04T07:56:28+0000"
    },
    {
        "name": "Russian",
        "code": "ru",
        "translations": 26,
        "percentage": 16.99,
        "updated": "2020-06-04T07:57:17+0000"
    },
    {
        "name": "Spanish",
        "code": "es",
        "translations": 145,
        "percentage": 94.77,
        "updated": "2023-03-26T12:54:09+0000"
    },
    {
        "name": "Swedish",
        "code": "sv",
        "translations": 27,
        "percentage": 17.65,
        "updated": "2020-06-04T07:43:55+0000"
    },
    {
        "name": "Thai",
        "code": "th",
        "translations": 26,
        "percentage": 16.99,
        "updated": "2020-06-04T07:57:53+0000"
    },
    {
        "name": "Turkish",
        "code": "tr",
        "translations": 27,
        "percentage": 17.65,
        "updated": "2020-06-04T07:23:37+0000"
    },
    {
        "name": "Vietnamese",
        "code": "vi",
        "translations": 26,
        "percentage": 16.99,
        "updated": "2020-06-04T07:54:35+0000"
    }
];
	